<template>
  <el-dialog :title="$t('text.editUser')" :visible.sync="dialogShow" @close="closeDialog">
    <el-form ref="form" label-width="120px">

      <el-form-item label="选取的数量">
        <div> {{ data.length }}</div>
      </el-form-item>

      <el-form-item :label="$t('text.atUserId')" class="custom-select-item">
        <div class="select-wrapper">
          <el-select
              v-model="selectedUserNames"
              multiple
              style="width: 100%"
              class="hidden-tags-select"
          >
            <el-option value="dummy" class="tree-option-container" style="height: auto; padding: 0;">
              <el-tree
                  :data="treeData"
                  show-checkbox
                  node-key="id"
                  ref="userTree"
                  highlight-current
                  @check-change="handleCheckChange"
              />
            </el-option>
          </el-select>

          <div class="tags-overlay" v-if="selectedUserNames.length > 0" @click="focusSelect">
            <el-tag
                v-for="(name, index) in displayTags"
                :key="index"
                size="mini"
                closable
                type="success"
                effect="dark"
                @close="removeTagByName(name)"
            >
              {{ name }}
            </el-tag>
            <el-tag v-if="selectedUserNames.length > 5" size="mini" type="info" effect="plain">
              + {{ selectedUserNames.length - 5 }}
            </el-tag>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" :loading="loading" @click="update">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    data: Array,
    appUserInfo: Array,
  },
  data() {
    return {
      dialogShow: this.show,
      selectedUserNames: [],
      atUserId: '',
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  computed: {
    displayTags() {
      return this.selectedUserNames.slice(0, 5);
    },
    treeData() {
      const groups = {};
      const users = this.appUserInfo || [];
      users.forEach(user => {
        if (!user.role) return;
        if (!groups[user.role]) {
          groups[user.role] = {
            id: `role_${user.role}`,
            label: user.role,
            isCategory: true,
            children: []
          };
        }
        groups[user.role].children.push({
          id: user.id.toString(),
          label: user.name,
          isCategory: false
        });
      });
      return Object.values(groups);
    }
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
      if (newVal) {
        this.$nextTick(() => {
          this.initSelection();
        });
      }
    }
  },
  methods: {
    initSelection() {
      const tree = this.$refs.userTree;
      if (!tree) return;
      if (this.data && this.data.atUserId) {
        const ids = this.data.atUserId.split(',');
        tree.setCheckedKeys(ids);
        this.syncSelectWithTree();
      } else {
        tree.setCheckedKeys([]);
        this.selectedUserNames = [];
      }
    },
    handleCheckChange() {
      this.syncSelectWithTree();
    },
    syncSelectWithTree() {
      const tree = this.$refs.userTree;
      if (!tree) return;
      const checkedNodes = tree.getCheckedNodes();
      const users = checkedNodes.filter(node => !node.isCategory);
      this.selectedUserNames = users.map(u => u.label);
      const ids = users.map(u => u.id);
      this.atUserId = ids.join(',')
    },
    removeTagByName(name) {
      const tree = this.$refs.userTree;
      if (!tree) return;

      const checkedNodes = tree.getCheckedNodes();
      const targetNode = checkedNodes.find(n => n.label === name && !n.isCategory);

      if (targetNode) {
        tree.setChecked(targetNode.id, false);
        this.syncSelectWithTree();
      }
    },
    focusSelect() {
      this.$el.querySelector('.el-input__inner').click();
    },
    update() {
      this.loading = true;
      let params = {
        keywords: this.data,
        atUserId: this.atUserId
      };

      console.log('Update params:', params);

      this.axios.put("/messagingAppKey/edit/bath", params).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.success'),
            message: res.msg,
            type: "success",
          });

          this.$bus.$emit("refresh"); //通知刷新

          this.closeDialog();
        } else {
          this.$notify.error({
            title: this.$t('text.error'),
            message: res.msg,
          });
        }
      });
      this.loading = false;
    },
    closeDialog() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style scoped>
.tree-option-container {
  overflow: auto;
  max-height: 250px;
}

.hidden-tags-select ::v-deep .el-select__tags {
  display: none !important;
}

.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.tags-overlay {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 5px;
  pointer-events: auto;
  max-width: 85%;
  overflow: hidden;
  white-space: nowrap;
}

.hidden-tags-select ::v-deep .el-input__inner {
  cursor: pointer;
}
</style>